<template>
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li
        v-for="(item, index) in items"
        :key="index"
        class="breadcrumb-item"
        :class="{ active: index === items.length - 1 }"
        aria-current="page"
      >
        <router-link
          v-if="item.route && index !== items.length - 1"
          :to="item.route"
        >
          <span>{{ item.label }}</span>
        </router-link>
        <span v-else>{{ item.label }}</span>
      </li>
    </ol>
  </nav>
</template>
<script lang="ts" setup>
  import { useBreadcrumbStore } from '@/store/breadCrumb'
  import { computed } from 'vue'

  interface BreadcrumbItem {
    label: string
    route?: string
    icon?: string
  }

  const breadcrumbStore = useBreadcrumbStore()
  const items = computed<BreadcrumbItem[]>(
    () => breadcrumbStore.breadcrumbItems
  )
</script>

<style scoped>
  .breadcrumb {
    display: flex;
    flex-wrap: wrap;
    padding: 0.75rem 1rem;
    margin-bottom: 1rem;
    font-size: 14px;
    list-style: none;
    background-color: none;
    border-radius: 0.25rem;
    width: 90%;
  }

  .breadcrumb a,
  .breadcrumb a:visited,
  .breadcrumb a:hover,
  .breadcrumb a:active {
    text-decoration: none;
    color: inherit;
  }

  .breadcrumb-item {
    display: flex;
    align-items: center;
    text-decoration: underline;
    color: #2563eb;
    cursor: pointer;
  }

  .breadcrumb-item + .breadcrumb-item::before {
    display: inline-block;
    padding-right: 0.5rem;
    padding-left: 0.5rem;
    color: #6c757d;
    content: '>';
  }

  .breadcrumb-item.active {
    color: #6c757d;
    font-weight: 400;
    text-decoration: none;
    cursor: default;
  }
</style>
